import { Avatar } from 'antd';
import styled from 'styled-components';

const UserAvatar = styled(Avatar)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
  backgroundColor: theme.palette.primary['500']
}));

export default UserAvatar;
